import { useContext } from 'react';

import type { TruncationMode } from '../../../typography/text-ellipsis/TextEllipsis.js';
import { TimeseriesTruncationModeContext } from '../context/TimeseriesTruncationMode.context.js';

export const useTruncationMode = (): TruncationMode =>
  useContext(TimeseriesTruncationModeContext);
